// Builders for the player-edit actions sent to recordUserSession /
// recordTokenUserSession. Each action is shaped as
// { actionType, loggedAt, payload: { kind, playerId, playerAssessmentId, ... } }.
// loggedAt is a Date so the action is assignable to the store's IUserAction;
// Apollo serializes it to the same ISO string the wire expects.

interface IPlayerEditAction {
  actionType: 'PLAYER_EDIT';
  loggedAt: Date;
  payload: Record<string, unknown>;
}

const playerEditAction = (playerId: string, playerAssessmentId: string, payload: Record<string, unknown>): IPlayerEditAction => ({
  actionType: 'PLAYER_EDIT',
  loggedAt: new Date(),
  payload: { playerId, playerAssessmentId, ...payload },
});

export const buildFieldsAction = (playerId: string, playerAssessmentId: string, fields: Record<string, unknown>): IPlayerEditAction =>
  playerEditAction(playerId, playerAssessmentId, { kind: 'fields', fields });

export const buildMilestoneAction = (playerId: string, playerAssessmentId: string, milestone: { type: PlayerMilestoneType; value: number; recordedAt: string }): IPlayerEditAction =>
  playerEditAction(playerId, playerAssessmentId, { kind: 'milestone', milestone });
